import { render, staticRenderFns } from "./BcCamera.vue?vue&type=template&id=3df57322&scoped=true"
import script from "./BcCamera.vue?vue&type=script&lang=js"
export * from "./BcCamera.vue?vue&type=script&lang=js"
import style0 from "./BcCamera.vue?vue&type=style&index=0&id=3df57322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df57322",
  null
  
)

export default component.exports